<template>
  <div>
    <el-card :shadow="'hover'">
      <div class="service-header">
        <h2 class="service-heading">
          Carrier Services Settings
        </h2>
        <div>
          <el-button
            size="small"
            round
            @click.native="$refs.bulkCreateForm.isShow = true"
          >
            <FontAwesomeIcon :icon="['fal', 'plus']" />&nbsp;Bulk Create
          </el-button>
          <el-button
            size="small"
            round
            @click.native="loadTable"
          >
            <FontAwesomeIcon :icon="['fal', 'sync']" />&nbsp;Refresh
          </el-button>
        </div>
      </div>
      <el-table
        v-loading="isLoading"
        :data="carrierServices"
        size="small"
        border
        stripe
      >
        <el-table-column
          label="Service"
          sortable
          :sort-method="sortServiceName"
          prop="carrier_service"
          :formatter="(row, col, cellValue) => cellValue ? (cellValue.name || '-') : '-'"
        />
        <el-table-column
          label="Service Type"
          prop="carrier_type"
          :formatter="(row, col, cellValue) => cellValue ? (cellValue.name || '-') : '-'"
        />
        <el-table-column
          label="Code"
          sortable
          :sort-method="sortServiceChainit"
          prop="carrier_service"
          :formatter="row => $_.get(row, 'carrier_service.chainit', '-')"
        />
        <el-table-column
          label="Cubic"
          prop="cubic"
          :formatter="(row, col, cellValue) => cellValue ? cellValue : '-'"
        />
        <el-table-column
          label="Extra Quote"
          prop="extra"
          :formatter="(row, col, cellValue) => cellValue ? `${cellValue * 100}%` : '-'"
        />
        <el-table-column
          label="Autobook"
          prop="autobook"
          :formatter="(row, col, cellValue) => cellValue ? 'Yes' : 'No'"
        />
        <el-table-column
          label="Transit Adjustment (Days)"
          prop="transit_modifier"
          :formatter="(row, col, cellValue) => cellValue > 0 ? `+${cellValue}` : `${cellValue || 0}`"
        />
        <el-table-column
          label="Pickup Type"
          prop="crm_pickuptype"
          :formatter="(row, col, cellValue) => cellValue ? 'PERM' : 'ADHOC'"
        />
        <el-table-column
          label="Actions"
          align="right"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click.native="editCarrierService(scope.$index, scope.row)"
            >
              Edit
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click.native="deleteCarrierService(scope.$index, scope.row)"
            >
              Delete
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- Pagination -->
      <br>
      <div style="text-align: center;">
        <el-pagination
          :current-page.sync="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="perPage"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="loadTable()"
          @current-change="loadTable()"
        />
      </div>
    </el-card>
    <!-- Bulk Create Form -->
    <CarrierServiceSettingsBulkCreateForm
      ref="bulkCreateForm"
      :account-id="accountId"
      :carrier-id="carrierId"
      @created="loadTable"
    />
    <!-- Edit Form Modal -->
    <CarrierServiceSettingEditModal
      ref="editModal"
      :account-id="accountId"
      @saved="loadTable"
    />
  </div>
</template>

<script>
import CarrierServiceSettingsBulkCreateForm from '@/components/Application/Manage/Account/CarrierServiceSettingsBulkCreateForm'
import CarrierServiceSettingEditModal from '@/components/Application/Manage/Account/CarrierServiceSettingEditModal'
export default {
  components: {
    CarrierServiceSettingsBulkCreateForm,
    CarrierServiceSettingEditModal
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    carrierId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      carrierServices: [],
      page: 1,
      perPage: 10,
      total: 0,
      isLoading: false
    }
  },
  created () {
    this.loadTable()
  },
  methods: {
    sortService (a, b) {
      return a.service.name.localeCompare(b.service.name)
    },
    sortServiceChainit (a, b) {
      return a.carrier_service.chainit.localeCompare(b.carrier_service.chainit)
    },
    loadTable () {
      this.isLoading = true
      this.$sdk.account_carrierservicesetting.list(builder => {
        builder.context = { resource: 'account', id: this.accountId }
        builder.include = ['carrier_service', 'carrier_type', 'service_rate_type']
        builder.filters = { carrier_service_strict_carrier: [this.carrierId] }
        builder.page = this.page
        builder.limit = this.perPage
        builder.order = 'carrier_service.name:asc'
      })
        .then(res => {
          this.carrierServices = res
          this.total = res.total
        })
        .finally(() => { this.isLoading = false })
    },
    editCarrierService (index, row) {
      this.$refs.editModal.carrierServiceSetting = row
      this.$refs.editModal.isShow = true
    },
    deleteCarrierService (index, row) {
      this.$confirm('Are you sure to delete this carrier service?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isLoading = true
        row.delete(builder => {
          builder.context = { resource: 'account', id: this.accountId }
        })
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.service-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0px 10px 0px;
    .service-heading {
      margin: 0;
    }
}
</style>
